import { defineStore } from 'pinia';
import { ref, Ref } from 'vue';
import { AsaPrivilege } from '@/enums/api/attribute-store-adapter/asa-privilege';

const privilegesStore = defineStore(
    'privileges-store',
    () => {
        const privileges: Ref<AsaPrivilege[]> = ref([]);

        return {
            privileges
        };
    },
    {
        persist: {
            pick: ['privileges']
        }
    }
);

export { privilegesStore };
